import type { ReactNode, FC } from "preact/compat";
import classnames from "classnames";
import { ComboboxModal } from "../ComboboxModal";
import "./index.scss";

export type ComboboxListboxProps = {
  children?: ReactNode;
  optional?: boolean;
  isMobile?: boolean;
  placeholder?: string;
  disabled_features?: Array<{ value: string }>;
  handleSelectLater?: (selected: boolean) => void;
  selectLater?: {
    value: string;
    label: string;
    selected?: boolean;
  };
  handleClose?: () => void;
  items?: {
    value: string;
    label: string;
  }[];
  disableSelectLater?: boolean;
  rebrand?: boolean;
};

export const ComboboxListbox: FC<ComboboxListboxProps> = ({
  children,
  optional,
  isMobile,
  placeholder,
  handleClose,
  items,
  selectLater,
  handleSelectLater,
  disabled_features,
  disableSelectLater,
  rebrand,
}) => {
  const handleSelectLaterClick = () => {
    handleSelectLater?.(!selectLater?.selected);
    handleClose?.();
  };

  const renderList = () => {
    if (isMobile) {
      return (
        <ComboboxModal>
          <div
            className={`combobox-listbox ${rebrand ? "combobox-listbox--rebrand" : ""} m-0 fixed bottom-0 top-0 ${
              items?.length && items.length <= 3 ? "" : "h-full"
            } overflow-hidden flex flex-col w-screen`}
          >
            <div class="flex h-24 shrink-0  items-center bg-white justify-between border-b-2 border-gt-lilac-dark">
              <div class="p-6 text-lg font-medium text-neutral-500">
                {placeholder}
              </div>
              <div class="px-6 text-neutral-700">
                <button
                  type="button"
                  class="combobox-listbox__done"
                  onClick={handleClose}
                >
                  {rebrand ? "Close" : "Done"}
                </button>
              </div>
            </div>
            <div class="flex grow flex-col overflow-y-scroll">
              <ul
                role="listbox"
                className="overflow-scroll bg-white border-b-2 border-gt-lilac-dark"
                aria-labelledby="downshift-4-label"
              >
                {optional && !rebrand && (
                  <div class="flex flex-col">
                    <span className="text-left text-xs uppercase leading-4 font-medium text-neutral-500 px-4 pt-4">
                      Optional
                    </span>

                    {disabled_features?.find(
                      (_f) => _f.value === "select later",
                    ) ? null : (
                      <>
                        {disableSelectLater ? null : (
                          <>
                            {selectLater && (
                              <span
                                class={classnames(
                                  "combobox-listbox__select-later",
                                  {
                                    "bg-gt-lilac-light":
                                      !!selectLater?.selected,
                                  },
                                )}
                                role="button"
                                onClick={handleSelectLaterClick}
                              >
                                {selectLater?.label}
                              </span>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                )}
                {children}
              </ul>
            </div>
          </div>
        </ComboboxModal>
      );
    }
    return (
      <div className={`combobox-listbox ${rebrand ? "combobox-listbox--rebrand" : ""} absolute z-10 mt-2 rounded-md border-2 border-gt-lilac-dark bg-white`}>
        <div className="m-1 overflow-auto overscroll-contain max-h-[240px]">
          <ul role="listbox" aria-labelledby="downshift-4-label">
            {optional && !rebrand && (
              <>
                <div class="combobox-listbox__sticky">
                  <span className="text-left text-xs uppercase leading-4 font-medium text-neutral-500">
                    Optional
                  </span>

                  <button
                    type="button"
                    className="combobox-listbox__done"
                    onClick={handleClose}
                  >
                    Done
                  </button>
                </div>

                {disabled_features?.find(
                  (_f) => _f.value === "select later",
                ) ? null : (
                  <>
                    {disableSelectLater ? null : (
                      <>
                        {selectLater && (
                          <span
                            class={classnames(
                              "combobox-listbox__select-later", {
                                "bg-gt-lilac-light": !!selectLater?.selected,
                              },
                            )}
                            role="button"
                            onClick={handleSelectLaterClick}
                          >
                            {selectLater?.label}
                          </span>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}

            {children}
          </ul>
        </div>
      </div>
    );
  };
  return <>{renderList()}</>;
};
